import { useStore } from '@ui/hooks/useStore';

const useCursor = () => {
    const { user, groups, devices } = useStore();
    let cursor = '';
    if (user.loading) cursor = 'wait';
    if (
        user.changeSettingsLoading ||
        user.registerLoading ||
        groups.loading ||
        groups.createGroupLoading ||
        groups.changeGroupDescriptionLoading ||
        groups.deleteGroupLoading ||
        groups.addDeviceLoading ||
        devices.loading ||
        devices.settingsLoading ||
        devices.addDeviceInDbLoading ||
        devices.changeDeviceDescriptionLoading ||
        devices.deleteDeviceLoading
    )
        cursor = 'progress';
    return cursor;
};

export default useCursor;
